module.exports = __webpack_public_path__ + "solanaproject/img/risk_warning.11335e83.svg";